import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Header } from '../../Header'
import { Image } from '../Image'

export const Container = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Header key='header'>{t('Logo')}</Header>

      <Image key='image' />
    </>
  )
}

Container.displayName = 'Logo'
